import { render } from "./BestPlans.vue?vue&type=template&id=a3c861d8"
import script from "./BestPlans.vue?vue&type=script&lang=js"
export * from "./BestPlans.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__